/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback } from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { useTranslator } from '@jutro/locale';
import { useDataRefresh, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import appConfig from 'app-config';
import { platformMessages } from 'ml-components-platform-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { PriorInsuranceComponent } from 'ml-capability-quoteandbind-common-react';
import { MLModalService } from 'ml-portals-services-react';

import messages from './MLCRPriorInsuranceValidationComponent.messages';

function MLCRPriorInsuranceValidationComponent(props) {

    const { 
        submissionVM,
        updateWizardData,
        onValidate,
        onUpdateErrors,
        showPriorInsuranceErrors,
        updateShowPriorInsuranceErrors,
        currentStep
     } = props;
    
    const { showProgressDialog } = MLModalService();
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const { refreshData } = useDataRefresh();
    const { authHeader } = useAuthentication();
    const translator = useTranslator();

    const quoteID = submissionVM.quoteID.value;
    const isGpa = appConfig.portalCode === 'GPA';
    const priorInsuranceQuestionSetData = _.get(submissionVM, 'lobData.personalAuto.questionSets_ML.priorInsurance.value');

    const syncPriorInsuranceQuestionSets = useCallback(() => {
        const syncPromise = LoadSaveService.syncQuestionSetML(quoteID, [priorInsuranceQuestionSetData], authHeader);

        setTimeout(() => {    
            showProgressDialog(platformMessages.syncingQuestions, syncPromise, true);
        }, 100);

        syncPromise.then((updatedQuestionSets) => {
            const priorInsuranceQs = updatedQuestionSets.find((q) => q.code === 'PAPriorInsurance_ML');
            _.set(submissionVM, 'lobData.personalAuto.questionSets_ML.priorInsurance.value', priorInsuranceQs);
            refreshData();
        }).catch(() => {
            _.noop();
        });
    }, [LoadSaveService, quoteID, priorInsuranceQuestionSetData, authHeader, showProgressDialog, submissionVM, refreshData]);

    return (
        <React.Fragment>
            <h2 className='section-header margin-top-sm margin-bottom-sm'>{translator(messages.priorInsuranceHeader)}</h2> 
            <PriorInsuranceComponent 
                submissionVM={submissionVM}
                updateWizardData = {updateWizardData}
                onValidate={onValidate}
                onUpdateErrors={onUpdateErrors}
                syncQuestionSets={syncPriorInsuranceQuestionSets}
                showErrors={showPriorInsuranceErrors}
                isGpa={isGpa}
                showPriorInsuranceErrors={showPriorInsuranceErrors}
                updateShowPriorInsuranceErrors={updateShowPriorInsuranceErrors}
                currentStep={currentStep}
            />
        </React.Fragment>
    );
}

MLCRPriorInsuranceValidationComponent.propTypes = {
    
};
MLCRPriorInsuranceValidationComponent.defaultProps = {
    
};
export default withRouter(MLCRPriorInsuranceValidationComponent);
